"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferMessagesListPathParamsSchema = exports.OfferMessageIdPathParamsSchema = exports.OfferMessageUpdateRequestSchema = exports.OfferMessageCreateRequestSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../../schemas");
const offers_1 = require("../../../../../schemas/offers");
const offers_validate_1 = require("../offers.validate");
exports.OfferMessageCreateRequestSchema = offers_1.OfferReminderSchema
    .omit({ id: true })
    .superRefine((v, ctx) => (0, offers_validate_1.validateSchedule)(ctx, v, 'isScheduled', 'scheduledAt'));
exports.OfferMessageUpdateRequestSchema = exports.OfferMessageCreateRequestSchema.partial();
exports.OfferMessageIdPathParamsSchema = zod_1.z.object({
    messageId: schemas_1.UUIDSchema,
    offerId: schemas_1.UUIDSchema,
}).strict();
exports.OfferMessagesListPathParamsSchema = zod_1.z.object({
    offerId: schemas_1.UUIDSchema,
}).strict();
